import { useState, useEffect, useRef } from "react";
import './UpgradeMode.css';
import { useAuth } from '../context/AuthContext';

const motivationalMessages = [
  "“Your creativity is your biggest investment.” 🌟",
  "“Every pause prepares you for a leap.” 🌱",
  "“Innovation starts with patience — you’re already ahead.” 🚀",
  "“Great things take time — your patience is your advantage.” 🌱",
  "“Your curiosity is your power!” 🌱"
];

export default function UpgradeMode() {
  const [visitors, setVisitors] = useState(0);
  const [notified, setNotified] = useState(false);
  const [countdown, setCountdown] = useState("");
  const [message, setMessage] = useState("");
  const timeoutRef = useRef(null);
  const { user } = useAuth();

  useEffect(() => {
    // Load from localStorage
    const storedNotified = localStorage.getItem('upgradeNotified');
    if (storedNotified === 'true') {
      setNotified(true);
    }

    // Fetch global count
    fetch('/api/upgrade/count')
      .then(res => res.json())
      .then(data => setVisitors(data.count))
      .catch(err => console.error('Error fetching count:', err));

    // Random message
    const randomMsg = motivationalMessages[Math.floor(Math.random() * motivationalMessages.length)];
    setMessage(randomMsg);

    // Calculate +2 months from now
    const targetDate = new Date();
    targetDate.setMonth(targetDate.getMonth() + 2);
    const interval = setInterval(() => {
      const diff = targetDate - new Date();
      if (diff <= 0) {
        setCountdown("Soon!");
        clearInterval(interval);
      } else {
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        setCountdown(`${days} days left`);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!notified) {
      timeoutRef.current = setTimeout(() => {
        window.location.href = "https://buymeacoffee.com/yourlink";
      }, 5000); // 5 seconds
    }
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [notified]);

  const handleNotify = () => {
    if (!notified) {
      setNotified(true);
      localStorage.setItem('upgradeNotified', 'true');
      // Clear the timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      // Post to backend
      fetch('/api/upgrade/notify', { method: 'POST' })
        .then(res => res.json())
        .then(data => setVisitors(data.count))
        .catch(err => console.error('Error notifying:', err));
    }
  };

  return (
    <div className="upgrade-mode">
      <h1 className="upgrade-title">🚧 We’re Evolving — Be the First to Know!</h1>
      <p className="upgrade-description">
        RapidMind is upgrading to bring you smarter, faster, and more creative tools.
        Come back in <strong>{countdown}</strong> to experience the next generation of innovation!
      </p>

      {!notified ? (
        <button onClick={handleNotify} className="claim-button">
          🎁 Claim Your VIP Access
        </button>
      ) : (
        <p className="vip-message">🎉 You’re on the VIP list! Treasure unlocked!</p>
      )}

      <p className="motivational-message">
        {message}
      </p>

      {/* Emotional Donation Section */}
      <div className="emotional-section">
        <p className="opportunity-title">🚨 LIMITED TIME: Super Amazing Opportunity — Don’t Miss Out! 🚨</p>
        <p className="opportunity-text">
          🌍 RapidMind is exploding with growth — and YOU could be the hero who makes it happen! ✨
          🚀 Your support isn’t just a donation; it’s your ticket to shaping the future of AI-powered creativity. ❤️
        </p>
        <p className="community-text">
          Join the <span className="text-yellow-100 underline">EXCLUSIVE VIP Community</span> of trailblazers —
          trusted by ⭐⭐⭐⭐⭐ creators, innovators, and dreamers worldwide!
        </p>
        <p className="legendary-text">
          💎 <strong>This is YOUR chance to be part of something legendary.</strong>
          As a VIP contributor, unlock EARLY ACCESS to mind-blowing features, premium perks, and insider updates that will blow your mind!
        </p>
        <p className="urgent-text">⏰ Spots are filling up fast — act NOW before it’s too late!</p>
        <a
          href="https://buymeacoffee.com/yourlink"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="support-button">
            ☕ Support RapidMind & Unlock VIP Features
          </button>
        </a>
        <p className="magic-quote">
          "Together, we’re not just building software — we’re creating MAGIC that will change the world." 🌟✨
        </p>
      </div>

      {user && user.email === 'seifeddinejamai8@gmail.com' ? (
        <p className="visitors-count">Visitors interested: {visitors}</p>
      ) : (
        <p className="visitors-count">
          Visitors interested: 50000
          <br />
          ⭐ ⭐ ⭐ ⭐ ⭐
        </p>
      )}
    </div>
  );
}